const isSm88 = (siteId: string) => {
	return ['4258600', '4227600'].includes(siteId);
};

export const siteService = {
	isSm88
};